import { getProfessionalCampaigns } from './GetProfessionalCampaigns';

export const CampaignsService = {
  getProfessionalCampaigns,
};
